<template>
  <div id="homepage" class="c-content">
    <div class="c-content__carousel">
      <q-carousel class='c-carousel__height' swipeable animated v-model="slide" infinite navigation navigation-icon='fa fa-circle-o' navigation-active-icon='fa fa-circle' transition-prev="slide-right" transition-next="slide-left">
        <q-carousel-slide v-for="(item, index) in banner" :name="index" :img-src="item.img" :key="index">
          <div :class="item.className">
            <h1>{{ item.title1 }}</h1>
            <p>{{ item.content }}</p>
          </div>
        </q-carousel-slide>
      </q-carousel>
    </div>

    <div class="c-introduce">
      <div class="c-introduce__block" v-for="(item,index) in introduce" :key="index">
        <div>
          <img :src="item.img" :alt="item.title">
          <h2>{{item.title}}</h2>
        </div>
        <p>{{item.text}}</p>
      </div>
    </div>

    <div class="c-publicity">
      <div class="c-publicity__flex c-publicity__flex--left">
        <div class="c-publicity__block c-publicity__block--text" :style="'background-color:'+ publicity.text[0].color">
          <div :class="publicity.text[0].theme == 'light' ? 'c-publicity__absolute c-publicity__light' : 'c-publicity__absolute c-publicity__deep' ">
            <h3 class='title_h3'>
              <p>{{publicity.text[0].title}}</p>
              <span>{{publicity.text[0].enTitle}}</span>
            </h3>
            <p class='c-publicity__text'>{{publicity.text[0].text}}</p>
            <p class='c-publicity__watch'>
              <q-btn outline class='c-publicity__watch--btn' @click='routeTo(publicity.text[0].link)' :label="homepage.more" padding="3px 2.5em" style='border-radius:0; color: #164687; line-height: 1.5em'/>
            </p>
          </div>
        </div>
        <div class="c-publicity__block">
          <q-parallax :src="publicity.img[1].url" class="c-publicity__block--height" :speed="1"></q-parallax>
        </div>
      </div>
      <div class="c-publicity__flex c-publicity__flex--right">
        <div class="c-publicity__block">
          <q-parallax :src="publicity.img[0].url" class="c-publicity__block--height" :speed="1"></q-parallax>
        </div>
        <div class="c-publicity__block c-publicity__block--text" :style="'background-color:'+ publicity.text[1].color">
          <div :class="publicity.text[1].theme == 'light' ? 'c-publicity__absolute c-publicity__light' : 'c-publicity__absolute c-publicity__deep' ">
            <h3 class='title_h3'>
              <p>{{publicity.text[1].title}}</p>
              <span>{{publicity.text[1].enTitle}}</span>
            </h3>
            <p class='c-publicity__text'>{{publicity.text[1].text}}</p>
            <p class='c-publicity__watch'>
              <q-btn outline class='c-publicity__watch--btn' @click='routeTo(publicity.text[1].link)' :label="homepage.more" padding="3px 2.5em" style='border-radius:0; color: #C6C6C6; line-height: 1.5em'/>
            </p>
          </div>
        </div>
      </div>
    </div>

    <counsel-block></counsel-block>

    <case-block style='padding-top: 0'></case-block>

    <team-work style='padding-top: 0'></team-work>

    <contact-form></contact-form>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import ContactForm from '../layout/contactForm.vue'
  import CaseBlock from '../layout/caseBlock.vue'
  import CounselBlock from '../layout/counselBlock.vue'
  import TeamWork from '../layout/teamWork.vue'

  export default {
    name: 'homepage',
    components: {
      'q-parallax': Quasar.QParallax,
      'q-carousel': Quasar.QCarousel,
      'q-carousel-slide': Quasar.QCarouselSlide,
      'q-btn': Quasar.QBtn,
      'contact-form': ContactForm,
      'case-block': CaseBlock,
      'counsel-block': CounselBlock,
      'team-work': TeamWork
    },
    data(){
      return {
        homepage: {
          more: this.$t('common.more')
        },
        slide: 0,
        banner: [
          {img: require('../../assets/img/home_banner_01.jpg'), title1:this.$t('homepage.banner.banner_1.title'), title2:"",content:this.$t('homepage.banner.banner_1.content'), className: "absolute-center c-carousel__block c-carousel__block--first"},
          {img: require('../../assets/img/home_banner_02.jpg'), title1:this.$t('homepage.banner.banner_2.title'), title2:"",content:this.$t('homepage.banner.banner_2.content'), className: "absolute-center c-carousel__block c-carousel__block--first"},
        ],
        introduce: [
          {title: this.$t('homepage.introduce.introduce_1.title'), img: require('../../assets/img/introduce_1.svg'), text: this.$t('homepage.introduce.introduce_1.content')},
          {title: this.$t('homepage.introduce.introduce_2.title'), img: require('../../assets/img/introduce_2.svg'), text: this.$t('homepage.introduce.introduce_2.content')},
          {title: this.$t('homepage.introduce.introduce_3.title'), img: require('../../assets/img/introduce_3.svg'), text: this.$t('homepage.introduce.introduce_3.content')},
        ],
        publicity: {
          text:[
            {link:'community', title: this.$t('homepage.publicity.publicity_1.title'),enTitle: this.$t('homepage.publicity.publicity_1.title_en'), color: '#F3F4F3', theme:'light',text: this.$t('homepage.publicity.publicity_1.content')},
            {link:'pension', title: this.$t('homepage.publicity.publicity_2.title'), enTitle: this.$t('homepage.publicity.publicity_2.title_en'), color: '#454545', theme:'deep', text: this.$t('homepage.publicity.publicity_2.content')}
          ],
          img:[
            {url:require('../../assets/img/publicity_1.jpg'), des:''},
            {url:require('../../assets/img/publicity_2.jpg'), des:''}
          ]
        }
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
  }
</script>

<style>

</style>
